export const DEFAULT_STATUS_CODE = 200
